import type { ReactNode } from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import LoadingSpinner from "../LoadingSpinner";

interface Props {
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  color?: string;
  loading?: boolean;
  size?: "small" | "default";
}

const ButtonContainer = styled.button<{
  color: string;
  disabled?: boolean;
  $size?: "small" | "default";
}>`
  width: ${(props) => (props.$size === "small" ? "24px" : "32px")};
  height: ${(props) => (props.$size === "small" ? "24px" : "32px")};
  border-radius: 50%;
  box-sizing: border-box;
  padding: 0;
  flex-shrink: 0;
  border: 1px solid
    ${(props) => (props.disabled ? theme.colors.disabled : props.color)};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${theme.shadow.circleButtonShadow};
  background-color: ${theme.colors.white};

  &:hover {
    cursor: pointer;
    box-shadow: none;
  }

  &:disabled {
    cursor: not-allowed;
  }

  & > svg {
    flex-shrink: 0;
  }

  & svg > path {
    stroke: ${(props) => (props.disabled ? theme.colors.disabled : undefined)};
  }
`;

const CircleButton: React.FC<Props> = ({
  icon,
  onClick,
  disabled,
  color = theme.colors.primary,
  loading,
  size = "default",
}) => {
  return (
    <ButtonContainer
      color={color}
      onClick={onClick}
      disabled={disabled || loading}
      $size={size}
    >
      {loading ? <LoadingSpinner /> : icon}
    </ButtonContainer>
  );
};
export default CircleButton;
